import React from 'react';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../actions/userActions';
import useTranslation from "../hooks/useTranslation";
import ReactCountryFlag from "react-country-flag";

const Header = ({language, setLanguage, t}) => {
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;

    const logoutHandler = () => {
        dispatch(logout());
    };

    return (
        <header>
            <Navbar
                bg='dark'
                expand='lg'
                variant='dark'
                collapseOnSelect
                className='p-3'
            >
                <Container>
                    <LinkContainer to='/home'>
                        <Navbar.Brand className='p-0 '>
                            <img src='smadify.png' width='120' height='40' alt='smadify logo'/>
                        </Navbar.Brand>
                    </LinkContainer>
                    <Navbar.Toggle aria-controls='basic-navbar-nav' />
                    <Navbar.Collapse id='basic-navbar-nav' className='align-bottom'>
                        <Nav className='ml-auto' activeKey={pathname}>
                            <LinkContainer to='/home'>
                                <Nav.Link style={{
                                    fontSize: '2 rem'
                                }}>{t('about_us')}</Nav.Link>
                            </LinkContainer>
                            {userInfo ? (
                                <>
                                    <NavDropdown
                                        title={t('players')}
                                        id='basic-nav-dropdown'
                                        className='mr-0'
                                    >
                                        <LinkContainer to='/players'>
                                            <NavDropdown.Item>{t('music_players')}</NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer to='/video_players'>
                                            <NavDropdown.Item>{t('video_players')}</NavDropdown.Item>
                                        </LinkContainer>
                                    </NavDropdown>
                                    <NavDropdown
                                        title={t('media')}
                                        id='basic-nav-dropdown'
                                        className='mr-0'
                                    >
                                        <LinkContainer to='/commercials'>
                                            <NavDropdown.Item>
                                                {t('commercials')}
                                            </NavDropdown.Item>
                                        </LinkContainer>

                                        <LinkContainer to='/signals'>
                                            <NavDropdown.Item>
                                                {t('signals')}
                                            </NavDropdown.Item>
                                        </LinkContainer>

                                        <LinkContainer to='/announcements'>
                                            <NavDropdown.Item href='/announcements'>
                                                {t('announcements')}
                                            </NavDropdown.Item>
                                        </LinkContainer>

                                        <LinkContainer to='/videos'>
                                            <NavDropdown.Item>
                                                {t('videos')}
                                            </NavDropdown.Item>
                                        </LinkContainer>
                                    </NavDropdown>
                                    <NavDropdown
                                        title={t('campaigns')}
                                        id='basic-nav-dropdown'
                                        className='mr-0'
                                    >
                                        <LinkContainer to='/campaigns'>
                                            <NavDropdown.Item>{t('campaigns')}</NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer to='/video_campaigns'>
                                            <NavDropdown.Item>{t('video_campaigns')}</NavDropdown.Item>
                                        </LinkContainer>
                                    </NavDropdown>
                                    <NavDropdown
                                        title={t('programmes')}
                                        id='basic-nav-dropdown'
                                        className='mr-0'
                                    >
                                        <LinkContainer to='/programmes'>
                                            <NavDropdown.Item>{t('music_programmes')}</NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer to='/video_programmes'>
                                            <NavDropdown.Item>{t('video_programmes')}</NavDropdown.Item>
                                        </LinkContainer>
                                    </NavDropdown>
                                    <NavDropdown
                                        title={userInfo.name}
                                        id='username'
                                        className={'mr-0'}
                                    >
                                        <LinkContainer
                                            to={`/profile/${userInfo._id}`}
                                        >
                                            <NavDropdown.Item>
                                                {t('profile')}
                                            </NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer
                                            to={`/settings/${userInfo._id}`}
                                        >
                                            <NavDropdown.Item>
                                                {t('general_settings')}
                                            </NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer
                                            to={`/downloads`}
                                        >
                                            <NavDropdown.Item>
                                                {t('downloads')}
                                            </NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer
                                            to={`/resources`}
                                        >
                                            <NavDropdown.Item>
                                                {t('resources_title')}
                                            </NavDropdown.Item>
                                        </LinkContainer>
                                        {userInfo.isAdmin ? (
                                            <>
                                            <LinkContainer to='/admin'>
                                                <NavDropdown.Item>
                                                    {t('admin')}
                                                </NavDropdown.Item>
                                            </LinkContainer>
                                            <LinkContainer to='/admin_video'>
                                                <NavDropdown.Item>
                                                    {t('admin_video_logs')}
                                                </NavDropdown.Item>
                                            </LinkContainer>
                                            <LinkContainer to='/admin_activities'>
                                                <NavDropdown.Item>
                                                    {t('admin_activities')}
                                                </NavDropdown.Item>
                                            </LinkContainer>
                                            <LinkContainer to='/admin_change'>
                                                <NavDropdown.Item>
                                                    {t('admin_change')}
                                                </NavDropdown.Item>
                                            </LinkContainer>
                                            <LinkContainer to='/admin_delete_user'>
                                                <NavDropdown.Item>
                                                    {t('admin_delete_user')}
                                                </NavDropdown.Item>
                                            </LinkContainer>
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                        <NavDropdown.Item
                                            onClick={logoutHandler}
                                        >
                                            {t('logout')}
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                    <NavDropdown id={'language'} title={(<ReactCountryFlag countryCode={language.toUpperCase()}/>)} className={'mr-0 ml-0'}>
                                        <NavDropdown.Item onClick={() => {setLanguage('hu');}}>
                                            <ReactCountryFlag countryCode={'HU'}/> HU
                                        </NavDropdown.Item>
                                        <NavDropdown.Item onClick={() => {setLanguage('gb');} }>
                                            <ReactCountryFlag countryCode={'GB'}/> EN
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                </>
                            ) : (
                                <LinkContainer to='/login'>
                                    <Nav.Link>
                                        <i className='fas fa-user' />{' '}
                                        {t('login')}
                                    </Nav.Link>
                                </LinkContainer>
                            )}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    );
};

export default Header;
